import "./home-button.css";
import React from "react";


export const HomeButtons = ({CreateRecordModal, getBearerToken}) => {

    return (
        <div className="home_button_allign">
            <CreateRecordModal getBearerToken={getBearerToken}/>
        </div>
    );
}